<template>
    <div class="section-loading-overlay">
      <div class="watercolor-particles"></div>
      <div class="watercolor-canvas">
        <div class="ink-diffusion"></div>
        <div class="fluid-layer fluid-1"></div>
        <div class="fluid-layer fluid-2"></div>
        <div class="fluid-layer fluid-3"></div>
        <div class="fluid-layer fluid-4"></div>
        <div class="droplet droplet-1"></div>
        <div class="droplet droplet-2"></div>
        <div class="droplet droplet-3"></div>
        <div class="ripple ripple-1"></div>
        <div class="ripple ripple-2"></div>
        <div class="ripple ripple-3"></div>
        <div class="splash splash-1"></div>
        <div class="splash splash-2"></div>
        <div class="splash splash-3"></div>
      </div>
      <div class="message-container">
        <div class="loading-message">
          {{ currentMessage }}
        </div>
        <div class="loading-subtitle">
          Mezclando conocimiento con amor
        </div>
        <div class="progress-dots">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'LoadingWatercolors',
    data() {
      return {
        messages: [
          "Creando tu respuesta perfecta ✨",
          "Mezclando sabiduría con creatividad 🎨",
          "Pintando conocimiento con amor 💜",
          "Organizando ideas brillantes 🌟",
          "Tejiendo conceptos educativos 🌈",
          "Preparando contenido de calidad 💖",
          "Fusionando arte y aprendizaje ✨",
          "Destilando sabiduría pura 🌸",
          "Creando magia educativa 🎭",
          "Cocinando la respuesta ideal 🔥"
        ],
        messageIndex: 0,
        currentMessage: "Creando tu respuesta perfecta ✨",
        messageInterval: null,
        particleInterval: null,
      };
    },
    mounted() {
      this.startLoading();
    },
    beforeDestroy() {
      this.stopLoading();
    },
    methods: {
      startLoading() {
        this.createWatercolorParticles();
        this.messageInterval = setInterval(this.changeMessage, 3000);
      },
      stopLoading() {
        clearInterval(this.messageInterval);
        clearInterval(this.particleInterval);
      },
      changeMessage() {
        this.currentMessage = this.messages[this.messageIndex];
        this.messageIndex = (this.messageIndex + 1) % this.messages.length;
      },
      createWatercolorParticles() {
        const container = this.$el.querySelector('.watercolor-particles');
        if (!container) return;
        const colors = [
          'rgba(78, 205, 196, 0.3)',
          'rgba(255, 107, 157, 0.3)',
          'rgba(255, 193, 7, 0.3)',
          'rgba(168, 230, 207, 0.2)',
          'rgba(44, 160, 141, 0.2)'
        ];
        for (let i = 0; i < 8; i++) {
          const particle = document.createElement('div');
          particle.className = 'w-particle';
          const size = Math.random() * 12 + 6;
          particle.style.width = size + 'px';
          particle.style.height = size + 'px';
          particle.style.left = Math.random() * 100 + '%';
          particle.style.background = `radial-gradient(circle, ${colors[Math.floor(Math.random() * colors.length)]} 0%, transparent 70%)`;
          particle.style.animationDelay = Math.random() * 8 + 's';
          particle.style.animationDuration = (Math.random() * 4 + 8) + 's';
          container.appendChild(particle);
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .section-loading-overlay {
    position: relative;
    min-height: 200px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 10;
    overflow: hidden;
  }
  
  .watercolor-canvas {
    position: relative;
    width: 120px;
    height: 120px;
    margin-bottom: 20px;
    overflow: hidden;
    border-radius: 50%;
  }
  
  .fluid-layer {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    animation: fluidMove 6s ease-in-out infinite;
  }
  
  .fluid-1 {
    background: radial-gradient(ellipse at 20% 30%,
        rgba(78, 205, 196, 0.8) 0%,
        rgba(78, 205, 196, 0.6) 25%,
        rgba(44, 160, 141, 0.4) 50%,
        rgba(44, 160, 141, 0.2) 75%,
        transparent 100%);
    animation-delay: 0s;
    transform-origin: 30% 40%;
  }
  
  .fluid-2 {
    background: radial-gradient(ellipse at 70% 60%,
        rgba(255, 107, 157, 0.7) 0%,
        rgba(255, 107, 157, 0.5) 30%,
        rgba(196, 69, 105, 0.3) 60%,
        rgba(196, 69, 105, 0.1) 80%,
        transparent 100%);
    animation-delay: -2s;
    transform-origin: 70% 60%;
  }
  
  .fluid-3 {
    background: radial-gradient(ellipse at 50% 80%,
        rgba(255, 193, 7, 0.7) 0%,
        rgba(255, 193, 7, 0.5) 35%,
        rgba(255, 152, 0, 0.3) 70%,
        rgba(255, 152, 0, 0.1) 85%,
        transparent 100%);
    animation-delay: -4s;
    transform-origin: 50% 80%;
  }
  
  .fluid-4 {
    background: radial-gradient(ellipse at 80% 20%,
        rgba(168, 230, 207, 0.6) 0%,
        rgba(168, 230, 207, 0.4) 35%,
        rgba(136, 216, 163, 0.2) 70%,
        transparent 100%);
    animation-delay: -1s;
    transform-origin: 80% 20%;
  }
  
  @keyframes fluidMove {
    0% {
      transform: scale(1) rotate(0deg) skew(0deg, 0deg);
      border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
    }
    25% {
      transform: scale(1.2) rotate(90deg) skew(5deg, -2deg);
      border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%;
    }
    50% {
      transform: scale(0.8) rotate(180deg) skew(-3deg, 4deg);
      border-radius: 70% 30% 40% 60% / 40% 70% 60% 30%;
    }
    75% {
      transform: scale(1.1) rotate(270deg) skew(2deg, -5deg);
      border-radius: 40% 70% 60% 30% / 70% 40% 30% 60%;
    }
    100% {
      transform: scale(1) rotate(360deg) skew(0deg, 0deg);
      border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
    }
  }
  
  .droplet {
    position: absolute;
    border-radius: 50% 50% 50% 0;
    transform: rotate(-45deg);
    opacity: 0;
    animation: dropletForm 5s ease-in-out infinite;
  }
  
  .droplet-1 {
    width: 12px;
    height: 12px;
    background: linear-gradient(135deg, rgba(78, 205, 196, 0.8), rgba(44, 160, 141, 0.6));
    top: 20px;
    left: 30px;
    animation-delay: 1s;
  }
  
  .droplet-2 {
    width: 10px;
    height: 10px;
    background: linear-gradient(135deg, rgba(255, 107, 157, 0.7), rgba(196, 69, 105, 0.5));
    top: 40px;
    right: 25px;
    animation-delay: 3s;
  }
  
  .droplet-3 {
    width: 8px;
    height: 8px;
    background: linear-gradient(135deg, rgba(255, 193, 7, 0.8), rgba(255, 152, 0, 0.6));
    bottom: 30px;
    left: 40px;
    animation-delay: 4s;
  }
  
  @keyframes dropletForm {
    0%, 80% {
      opacity: 0;
      transform: rotate(-45deg) scale(0);
    }
    85% {
      opacity: 1;
      transform: rotate(-45deg) scale(1);
    }
    100% {
      opacity: 0;
      transform: rotate(-45deg) scale(0) translateY(30px);
    }
  }
  
  .ripple {
    position: absolute;
    border: 2px solid rgba(78, 205, 196, 0.4);
    border-radius: 50%;
    animation: rippleExpand 3s ease-out infinite;
  }
  
  .ripple-1 {
    width: 30px;
    height: 30px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-delay: 0s;
  }
  
  .ripple-2 {
    width: 30px;
    height: 30px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-delay: 1s;
    border-color: rgba(255, 107, 157, 0.4);
  }
  
  .ripple-3 {
    width: 30px;
    height: 30px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation-delay: 2s;
    border-color: rgba(255, 193, 7, 0.4);
  }
  
  @keyframes rippleExpand {
    0% {
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      width: 120px;
      height: 120px;
      opacity: 0;
    }
  }
  
  .splash {
    position: absolute;
    background: radial-gradient(circle, rgba(78, 205, 196, 0.6) 0%, transparent 70%);
    border-radius: 50%;
    animation: splashEffect 4s ease-in-out infinite;
  }
  
  .splash-1 {
    width: 15px;
    height: 15px;
    top: 15%;
    left: 20%;
    animation-delay: 0.5s;
  }
  
  .splash-2 {
    width: 12px;
    height: 12px;
    top: 70%;
    right: 20%;
    background: radial-gradient(circle, rgba(255, 107, 157, 0.5) 0%, transparent 70%);
    animation-delay: 2s;
  }
  
  .splash-3 {
    width: 18px;
    height: 18px;
    bottom: 15%;
    left: 60%;
    background: radial-gradient(circle, rgba(255, 193, 7, 0.6) 0%, transparent 70%);
    animation-delay: 3s;
  }
  
  @keyframes splashEffect {
    0%, 90% {
      transform: scale(0);
      opacity: 0;
    }
    95% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(1.2);
      opacity: 0;
    }
  }
  
  .ink-diffusion {
    position: absolute;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 50% 50%,
        transparent 0%,
        rgba(78, 205, 196, 0.1) 25%,
        rgba(255, 107, 157, 0.1) 50%,
        rgba(255, 193, 7, 0.1) 75%,
        transparent 100%);
    border-radius: 50%;
    animation: inkSpread 8s ease-in-out infinite;
  }
  
  @keyframes inkSpread {
    0%, 100% {
      transform: scale(0.8) rotate(0deg);
      opacity: 0.6;
    }
    50% {
      transform: scale(1.3) rotate(180deg);
      opacity: 0.3;
    }
  }
  
  .message-container {
    text-align: center;
    max-width: 300px;
  }
  
  .loading-message {
    font-size: 1rem;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 10px;
    opacity: 0;
    animation: fadeInOut 3s ease-in-out infinite, gradientShift 5s ease-in-out infinite;
    background: linear-gradient(135deg, #4ecdc4 0%, #ff6b9d 40%, #ffc107 80%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    background-size: 200% 200%;
  }
  
  @keyframes gradientShift {
    0%, 100% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
  }
  
  .loading-subtitle {
    font-size: 0.8rem;
    color: #7f8c8d;
    opacity: 0.8;
    animation: pulse 2s ease-in-out infinite alternate;
  }
  
  @keyframes fadeInOut {
    0%, 100% {
      opacity: 0;
      transform: translateY(5px);
    }
    50% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  @keyframes pulse {
    0% {
      opacity: 0.6;
    }
    100% {
      opacity: 1;
    }
  }
  
  .progress-dots {
    display: flex;
    gap: 8px;
    margin-top: 15px;
    justify-content: center;
  }
  
  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4ecdc4, #44a08d);
    animation: dotFlow 1.8s ease-in-out infinite;
    position: relative;
  }
  
  .dot::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: inherit;
    opacity: 0.3;
    animation: dotRipple 1.8s ease-out infinite;
  }
  
  .dot:nth-child(2) {
    animation-delay: 0.3s;
    background: linear-gradient(135deg, #ff6b9d, #c44569);
  }
  
  .dot:nth-child(3) {
    animation-delay: 0.6s;
    background: linear-gradient(135deg, #ffc107, #ff9800);
  }
  
  @keyframes dotFlow {
    0%, 100% {
      transform: scale(0.8) translateY(0);
      opacity: 0.7;
    }
    50% {
      transform: scale(1.2) translateY(-5px);
      opacity: 1;
    }
  }
  
  @keyframes dotRipple {
    0% {
      transform: scale(1);
      opacity: 0.3;
    }
    100% {
      transform: scale(2.5);
      opacity: 0;
    }
  }
  
  .watercolor-particles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    overflow: hidden;
  }
  
  .w-particle {
    position: absolute;
    border-radius: 50%;
    opacity: 0;
    animation: watercolorFloat 8s linear infinite;
  }
  
  .w-particle:nth-child(odd) {
    border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
  }
  
  .w-particle:nth-child(even) {
    border-radius: 30% 60% 70% 40% / 50% 60% 30% 60%;
  }
  
  @keyframes watercolorFloat {
    0% {
      transform: translateY(120px) rotate(0deg) scale(0);
      opacity: 0;
    }
    15% {
      opacity: 0.4;
      transform: translateY(100px) rotate(54deg) scale(1);
    }
    85% {
      opacity: 0.2;
      transform: translateY(-20px) rotate(306deg) scale(0.8);
    }
    100% {
      transform: translateY(-40px) rotate(360deg) scale(0);
      opacity: 0;
    }
  }
  </style>
  